

















































































































import axios from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mailValid } from '@/mixins/regex';
import SingleSelect from '@/components/SingleSelect.vue';
import { TextValuePair } from '@/models/TextValuePair';
import SimulatorPrice from './SimplatorPrice.vue';
import PriceDisplay from './PriceDispay.vue';
import ConsentCheck from '@/components/ConsentCheck.vue';
import { EventTracker } from '@/mixins/eventTracker';
declare var grecaptcha: any;

export type SimulatorSummaryItem = {
    menuName: string;
    itemName: string;
    articleNumber?: string;
};
export type SimulatorData = {
    type: string;
    summary: SimulatorSummaryItem[];
    totalPrice: string;
    configurationImageUrl: string;
    configurationUrl: string;
    id: string;
};
type RetailerDropDown = {
    name: string;
    city: string;
    organizationId: string;
};
type SimulatorSet = {
    id: string;
    text: string;
};
export type SimulatorCampaign = {
    text: string;
    percentage: number;
    url: string;
    discount: string;
    campaignPrice: string;
    ignore?: boolean;
};
type ShareRequest = {
    token: string;
    url: string;
    customerMail: string;
    retailerId?: string | null;
};
type ApiResponse = {
    success: boolean;
    message: string;
    error: string;
};
@Component({
    components: {
        SingleSelect,
        SimulatorPrice,
        PriceDisplay,
        ConsentCheck
    }
})
export default class SimulatorSummary extends Vue {
    [x: string]: any;
    showSummary: boolean = false;
    simulatorData: SimulatorData | null = null;
    email: string = '';
    emailCustomer: string = '';
    retailers: RetailerDropDown[] | null = null;
    simulatorSets: SimulatorSet[] | null = null;
    simulatorSetText: string | null = null;
    simulatorCampaign: SimulatorCampaign | null = null;
    sentToRetailer: boolean = false;
    sentToEmail: boolean = false;
    retailer: string = '';
    path: string = '';
    parentUrl: string = '';
    recaptchaString: string;
    isLoading: boolean = false;
    consentChecked: boolean = false;
    dataLayer = (window as any).dataLayer || [];
    errors: { [key: string]: boolean } = {
        retailer: false,
        emailCustomer: false,
        email: false
    };
    ignoreCampaignSets: string[] = ['Ballingslov_Set136'];

    constructor() {
        super();
        this.retailers = JSON.parse(this.$attrs['data-retailers']) as RetailerDropDown[];
        this.simulatorSets = JSON.parse(this.$attrs['data-simulator-sets']) as SimulatorSet[];
        if (typeof this.$attrs['data-campaign'] !== 'undefined' && this.$attrs['data-campaign'] !== null) {
            this.simulatorCampaign = JSON.parse(this.$attrs['data-campaign']) as SimulatorCampaign;
        } else {
            this.simulatorCampaign = this.emptyCampaign;
        }
        this.parentUrl = this.$attrs['data-parent-url'];
        this.recaptchaString = this.$attrs['data-recaptcha-site-key'];
    }

    mounted() {
        const sc = document.getElementById('sparkClient');
        if (sc) {
            window.addEventListener('message', this.receiveMessage);
        }
    }

    unmounted() {
        window.removeEventListener('message', this.receiveMessage);
    }

    get retailerOptions(): TextValuePair[] {
        if (!this.retailers) return [];
        const retailers = this.retailers.map((retailer: RetailerDropDown) => {
            return {
                text: retailer.city != '' ? retailer.city + ' - ' + retailer.name : retailer.name,
                value: retailer.organizationId
            };
        });
        return retailers || [];
    }

    @Watch('showSummary')
    onSimulatorDataChange() {
        const header = document.getElementById('header-navigation');
        this.sentToEmail = this.sentToRetailer = false;
        if (this.showSummary && header) {
            const header = document.getElementById('header-navigation');
            if (header) {
                header.style.zIndex = '0';
            }
        } else if (header) {
            header.style.zIndex = '10000';
        }
    }

    selectRetailer(value: string[]) {
        this.retailer = value[0];
    }

    clipConfigUrl() {
        if (!this.path) return;
        EventTracker.trackEvent('simulator-copy-url');
        navigator.clipboard.writeText(this.path || '');
    }

    receiveMessage(event: MessageEvent) {
        if (event.origin !== 'https://ds.spark-vision.com') return;
        this.simulatorData = event.data;
        this.setCampaignPrice();
    }

    get emptyCampaign(): SimulatorCampaign {
        return {
            text: '',
            percentage: 0,
            url: '',
            discount: '',
            campaignPrice: '',
            ignore: true
        };
    }

    setCampaignPrice() {
        if (
            this.simulatorData &&
            this.simulatorData.totalPrice &&
            this.simulatorData.configurationUrl &&
            this.simulatorCampaign &&
            this.simulatorCampaign.percentage &&
            this.simulatorCampaign.percentage > 0
        ) {
            const configString = this.simulatorData.configurationUrl.match(/config_string=([^&]+)/);
            const setId = configString ? decodeURIComponent(configString[1]).split(/[;-]/)[0] : null;
            if (setId && this.ignoreCampaignSets.indexOf(setId) > -1) {
                this.simulatorCampaign.ignore = true;
            } else {
                this.simulatorCampaign.ignore = false;
            }
            const cleanedValue = this.simulatorData.totalPrice.replace(/[^\d]/g, '');
            const numberValue = parseInt(cleanedValue, 10);
            let campaignDiscount = numberValue * (this.simulatorCampaign.percentage / 100);
            campaignDiscount = Math.round(campaignDiscount);
            const campaignPrice = numberValue - campaignDiscount;
            this.simulatorCampaign.campaignPrice = campaignPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            this.simulatorCampaign.discount = campaignDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
    }

    openShowSummary() {
        const header = document.getElementById('header-navigation');
        if (header) {
            header.style.zIndex = '0';
        }
        let path = window.location.href.split('?')[0];
        let setId = null;
        if (this.simulatorData) {
            if (this.simulatorData.configurationUrl.split('?').length > 0) {
                const queryString: string = this.simulatorData.configurationUrl.split('?')[1];
                path = path + '?' + queryString;
                const queryStrings: string[] = queryString.split('&');

                queryStrings.forEach(e => {
                    if (e.startsWith('config_string') && e.split('=').length > 0) {
                        const setId1 = e.split('=')[1];
                        if (setId1.split('%3B').length > 0) {
                            setId = setId1.split('%3B')[0];
                        }
                    }
                });
            }
        }
        this.getSimulatorSet(setId);
        this.path = path;
        this.showSummary = true;
    }

    getSimulatorSet(setId: string | null) {
        this.simulatorSetText = null;
        if (this.simulatorSets && this.simulatorSets.length > 0 && setId) {
            const foundSet = this.simulatorSets.find((i: SimulatorSet) => i.id === setId);

            if (foundSet !== undefined && foundSet.text !== undefined) {
                this.simulatorSetText = foundSet.text;
            }
        }
    }

    send(endpoint: string) {
        this.errorMsgs = [];
        const recaptchaSiteKey = this.recaptchaString; //(window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm(endpoint) || this.isLoading) {
            return;
        } else {
            this.isLoading = true;
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token, endpoint);
                    });
            });
        }
    }

    submit(token: string, endpoint: string) {
        // if (this.concentPolicy) {
        const request: ShareRequest = {
            token: token,
            url: this.path,
            customerMail: endpoint == 'retailer' ? this.emailCustomer : this.email,
            retailerId: this.retailer == '' ? null : this.retailer
        };

        const requestContext = (window as any).__litium.requestContext;
        axios({
            method: 'post',
            url: `/api/share/simulator/${endpoint}`,
            data: request,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then((response: any) => {
                const apiResponse: ApiResponse = response.data;
                this.isLoading = false;
                if (apiResponse.success) {
                    // const self = this;
                    // setTimeout(function() {
                    //     self.isLoaded = true;
                    // }, 600);
                    if (endpoint == 'retailer') {
                        this.sentToRetailer = true;
                        const retailer = this.retailerOptions.find(e => e.value == this.retailer);
                        if (typeof retailer !== 'undefined') {
                            EventTracker.trackEvent('simulator-share-config', retailer.text);
                            this.dataLayer.push({
                                event: 'reseller-share-config',
                                email: request.customerMail,
                                store: retailer.text
                            });
                        }
                    } else {
                        this.sentToEmail = true;
                    }
                } else {
                    console.error(apiResponse);
                }
            })
            .catch((e: any) => {
                // handle error
                console.error(e);
            });
        // } else if (!this.concentPolicy && this.showDiscountCreationCode) {
        //     this.isLoading = false;
        //     this.concentPolicyMissing = true;
        // } else {
        //     this.isLoading = false;
        // }
    }

    validateForm(endpoint: string): boolean {
        let returnValue = true;
        if (endpoint == 'retailer') {
            if (this.retailer == '') {
                this.errors['retailer'] = true;
                returnValue = false;
            }
            if (!mailValid(this.emailCustomer)) {
                this.errors['emailCustomer'] = true;
                returnValue = false;
            }
        } else {
            if (!mailValid(this.email)) {
                this.errors['email'] = true;
                returnValue = false;
            }
        }
        return returnValue;
    }

    clearError(fieldName: string) {
        this.errors[fieldName] = false;
    }
}
